import {FX_ONE} from '../sim/core/fixed';
/** Convert UI normalized axes into the frozen signed16.16 wire contract. */
export function fieldMoveInput(x:number,y:number):{dirX:number;dirY:number;run:false}{
 const length=Math.hypot(x,y),scale=length>1?1/length:1;
 return{dirX:Math.round(x*scale*FX_ONE),dirY:Math.round(y*scale*FX_ONE),run:false};
}
